<template>
  <div class="wrapper">
    <div>
     
      <div>
        <dashboard-content>
        </dashboard-content>
      </div>
    </div>
   
  </div>
  
</template>
<style lang="scss">

</style>
<script>
  import { defineComponent, ref } from 'vue';

  import DashboardContent from './Content.vue'
  import { useAuthUserStore } from '@stores/auth';
  import { useSessionStore } from '@stores/session';
  import { Capacitor } from '@capacitor/core';
  
  export default defineComponent({
    components: {
     
      DashboardContent
    },
    setup() {
      const authStore = useAuthUserStore();


      return {
        authStore
      };
    },
    methods: {
      closeSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    }
  });

</script>


<style scoped>


.no-margin {
  margin: 0;
}
.native-top {
  margin-top: 20px;
}
.native-spacing {
    margin-top: 20px;
  }
.native-spacing2 {
  margin-top: 100px;
}
.f-top {
  top: 20px;
  left: 0;
  width: 100%;
}

.wrapper::after {
  content: "";
  display: table;
  clear: both;
}
</style>